// extracted by mini-css-extract-plugin
export var accordion = "styles-module--accordion--2e71b";
export var accordionContent = "styles-module--accordionContent--35e4b";
export var chevronDown = "styles-module--chevronDown--3ce6f";
export var expandButton = "styles-module--expandButton--0c4b8";
export var filterContainer = "styles-module--filterContainer--456f4";
export var filterItem = "styles-module--filterItem--bd6c0";
export var isExpanded = "styles-module--isExpanded--7b10b";